import { Ticket, CalendarDays, Store, Flame } from "lucide-react";

const fmtDate = (s) => {
  if (!s) return null;
  const [y, m, d] = s.split("-");
  return `${d}/${m}/${y.slice(2)}`;
};

/** Días que faltan para que venza (null si no tiene fecha). 0 = vence hoy. */
export function daysLeft(validUntil) {
  if (!validUntil) return null;
  const [y, m, d] = validUntil.split("-").map(Number);
  const end = new Date(y, m - 1, d);
  const today = new Date(); today.setHours(0, 0, 0, 0);
  return Math.round((end - today) / 86400000);
}

export const urgencyLabel = (n) => (n === 0 ? "¡Vence HOY!" : n === 1 ? "Vence mañana" : n === 2 ? "Vence en 2 días" : null);

/**
 * CouponCard — tarjeta visual del cupón (4:5). La IA genera el arte sin texto;
 * aquí superponemos descuento, producto, vigencia y condiciones.
 */
export default function CouponCard({ coupon, merchantName, code, status, compact = false, className = "", testid, holeColor = "#FAFAFA" }) {
  const img = coupon.image;
  const until = fmtDate(coupon.valid_until);
  const redeemed = status === "redeemed";
  const expired = status === "expired";
  const muted = redeemed || expired;
  const left = daysLeft(coupon.valid_until);
  const urgent = !muted && left !== null && left >= 0 && left <= 2;

  return (
    <div
      data-testid={testid}
      className={`relative overflow-hidden rounded-[28px] aspect-[4/5] text-white shadow-xl select-none ${muted ? "saturate-0 opacity-75" : ""} ${className}`}
    >
      {img ? (
        <img src={img} alt="" className="absolute inset-0 w-full h-full object-cover" draggable={false} />
      ) : (
        <div className="absolute inset-0 bg-gradient-to-br from-[#FF007A] via-[#7b2cff] to-[#0055FF]" />
      )}
      <div className="absolute inset-0 bg-gradient-to-t from-black/90 via-black/45 to-black/10" />

      <div className="absolute top-3 left-3 right-3 flex items-start justify-between gap-2">
        <span className="inline-flex items-center gap-1.5 rounded-full bg-white/15 backdrop-blur-md px-2.5 py-1 text-[10px] font-bold uppercase tracking-widest truncate">
          <Store className="w-3 h-3 shrink-0" /> <span className="truncate">{merchantName || "Tu comercio"}</span>
        </span>
        {urgent ? (
          <span className="inline-flex items-center gap-1 rounded-full bg-amber-400 text-black px-2.5 py-1 text-[10px] font-extrabold uppercase tracking-widest shadow-lg shrink-0 animate-pulse" data-testid={testid ? `${testid}-urgent` : undefined}>
            <Flame className="w-3 h-3" /> {urgencyLabel(left)}
          </span>
        ) : (
          <span className="rounded-full bg-[#FF007A] px-2.5 py-1 text-[10px] font-extrabold uppercase tracking-widest shadow-lg shrink-0">
            {redeemed ? "Canjeado" : expired ? "Vencido" : "Cupón"}
          </span>
        )}
      </div>

      <div className={`absolute inset-x-0 bottom-0 ${compact ? "p-4" : "p-5"}`}>
        <div className={`font-heading font-black leading-none tracking-tight drop-shadow-lg ${compact ? "text-4xl" : "text-5xl"}`} data-testid={testid ? `${testid}-discount` : undefined}>
          {coupon.discount_label}
        </div>
        <div className={`font-heading font-extrabold mt-1.5 leading-tight ${compact ? "text-base" : "text-xl"}`}>
          {coupon.title || "Producto o servicio"}
        </div>
        {coupon.headline && !compact && <p className="text-sm text-white/85 mt-1 leading-snug line-clamp-2">{coupon.headline}</p>}
        <div className="mt-3 flex items-center gap-2 text-[11px] text-white/80 flex-wrap">
          {until && (
            <span className={`inline-flex items-center gap-1 rounded-full px-2 py-0.5 ${urgent ? "bg-amber-400/25 text-amber-200 font-bold" : "bg-white/10"}`}><CalendarDays className="w-3 h-3" /> Vence {until}</span>
          )}
          {coupon.estimated_saving > 0 && (
            <span className="inline-flex items-center gap-1 rounded-full bg-emerald-400/20 text-emerald-200 px-2 py-0.5 font-bold">Ahorras ${coupon.estimated_saving.toFixed(0)}</span>
          )}
        </div>
        {coupon.conditions && !compact && (
          <p className="text-[10px] text-white/60 mt-2 leading-snug line-clamp-2">{coupon.conditions}</p>
        )}
        {code && (
          <div className="mt-3 flex items-center gap-2 rounded-2xl bg-white text-black px-3 py-2">
            <Ticket className="w-4 h-4 text-[#FF007A]" />
            <span className="font-mono font-extrabold tracking-[0.2em] text-base" data-testid={testid ? `${testid}-code` : undefined}>{code}</span>
          </div>
        )}
      </div>

      {/* Perforación tipo ticket */}
      <div className="absolute -left-3 top-[62%] w-6 h-6 rounded-full" style={{ background: holeColor }} />
      <div className="absolute -right-3 top-[62%] w-6 h-6 rounded-full" style={{ background: holeColor }} />
    </div>
  );
}
